var map = {
	"./anm-card.png": 576,
	"./app-install-icon.webp": 1680,
	"./arrow.png": 577,
	"./btn-blue-m-v2.png": 578,
	"./btn-blue-m.png": 579,
	"./btn-white-m-v2.png": 580,
	"./btn-white-m.png": 581,
	"./dummy-1.png": 582,
	"./eeziepay.svg": 583,
	"./fcl.svg": 584,
	"./fpx-logo.svg": 585,
	"./game-blue.png": 586,
	"./game-img.png": 587,
	"./game-white.png": 588,
	"./global-language.svg": 589,
	"./ifm-logo.svg": 590,
	"./logo-anniversary.png": 591,
	"./logo-christmas.png": 592,
	"./logo-cny-dragon.png": 593,
	"./logo-cny.png": 594,
	"./logo-halloween.png": 595,
	"./logo-merdeka.png": 596,
	"./logo-mooncake.png": 597,
	"./logo-raya.png": 598,
	"./logo-uefa.png": 599,
	"./merchant-logo.png": 96,
	"./modal-bg.jpg": 600,
	"./number-bg.png": 601,
	"./pagcor.svg": 602,
	"./pool-bg.png": 603,
	"./side-bar-bg.png": 604,
	"./tether.svg": 605,
	"./x33-logo-wc.png": 606,
	"./x33-logo.png": 607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 786;